import React,{useState,useEffect} from 'react'



const Comment = (props) => {
    const [readMore,setReadMore] = useState(false);

    const {comment} = props;


    // useEffect(()=>{
    //   const readMore = comment.snippet.topLevelComment.snippet.textDisplay.length > 35 ? true : false;
    //   setReadMore(readMore);
    // },[comment])

    const getPublishedDate = (date)=>{
        let today = new Date().toISOString().slice(0, 10)
        const year = parseInt(today.slice(0,4)) - parseInt(date.slice(0,4));
        
        if(year === 0 ){
          const month = parseInt(today.slice(5,7)) - parseInt(date.slice(5,7));
    
          if(month === 0){
            const day = parseInt(today.slice(8,10)) - parseInt(date.slice(8,10));
            if(day === 0){
              return "Today";
            }
            else{
              return `${day} days ago`;
            }
          }
          else{
            return `${month} months ago`;
          }
      }
      else{
        return `${year} years ago`;
      }
    };

    const handleClick = ()=>{
        setReadMore(!readMore);
    }

    const len = comment.snippet.topLevelComment.snippet.textDisplay.length;


  return (
    <div className='comment flex space-x-2' >
    <img className="w-[40px] h-[40px] rounded-full md:w-[50px] md:h-[50px]" src={comment.snippet.topLevelComment.snippet.authorProfileImageUrl} alt=""/>
    <div className='info flex flex-col  justify-center space-y-1'>
        <div className='flex space-x-2'>
          <p className="text-md font-medium text-white">{comment.snippet.topLevelComment.snippet.authorDisplayName}</p>
          <span className='text-[#aaa] text-sm'>{getPublishedDate(comment.snippet?.topLevelComment.snippet.publishedAt.slice(0,10))}</span>
        </div>
        <span className='text-sm text-[#aaa] md:hidden'>{comment.snippet.topLevelComment.snippet.textDisplay.slice(0,35)}
        {!readMore  ? 
        (len > 35 ? <span className='hover:text-blue-500 text-[#aaa]'  font-medium onClick={handleClick}>  Read more ....</span> : " ")
        :
        comment.snippet.topLevelComment.snippet.textDisplay.slice(35) }</span>
        <span className='hidden md:block text-sm text-[#aaa] '>
        {comment.snippet.topLevelComment.snippet.textDisplay}
        </span>
    </div> 
      </div>
    
  )
}

export default Comment;
